import { createRouter } from "@tanstack/react-router";
import { NotFound, RouteError, RoutePending } from "./app/route-states";
import { queryClient } from "./lib/api/query-client";
import { setCreateOrgNavigator } from "./lib/reauth";
import { routeTree } from "./routeTree.gen";

export function createAppRouter() {
  const router = createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    defaultPendingComponent: RoutePending,
    defaultPendingMs: 250,
    defaultErrorComponent: RouteError,
    defaultNotFoundComponent: NotFound,
    scrollRestoration: true,
  });
  // "Create your organization" from toasts (no current org) without a full reload (mock data survives)
  setCreateOrgNavigator(() => void router.navigate({ to: "/create-org" }));
  return router;
}

export type AppRouter = ReturnType<typeof createAppRouter>;

declare module "@tanstack/react-router" {
  interface Register {
    router: AppRouter;
  }
}
